<script>
  import ClickOut from '../../../../utils/directives/clickout'
  import AclCheckMixins from '../mixins/AclCheckMixins'

export default{
    mixins: [AclCheckMixins],
    data () {
      return {
        open: false
      }
    },
    computed: {},
    mounted () {
      this.popupItem = this.$el
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      },
      clicked: function (e) {
        console.log('prevented!')
        e.preventDefault()
      }
    },
    directives: {ClickOut}
  }
</script>

<template>
  <li :class="{ active: open }">
    <a v-click-out="hide" @click="toggle" class="auto">
      <span class="pull-right text-muted">
      <i class="fa fa-fw fa-angle-right text"></i>
      <i class="fa fa-fw fa-angle-down text-active"></i>
      </span>
      <i class="icon-settings icon "></i>
      <span>Configurações</span>
    </a>
    <ul class="nav nav-sub dk">
      <li class="nav-sub-header"><a><span class="text-muted teste">Configurações</span></a></li>
      <li>
        <!--router-link to="#"><span>Contas Bancárias</span></router-link-->
        <router-link :to="{ name: 'config.categorias.veiculares' }"><span>Categorias Veiculares</span></router-link>
      </li>
      <li>
        <!--router-link to="#"><span>Contas Bancárias</span></router-link-->
        <router-link :to="{ name: 'config.estado.lote' }"><span>Estado do Lote</span></router-link>
      </li>
      <li>
        <router-link :to="{ name: 'config.contratos' }"><span>Contratos</span></router-link>
      </li>
      <li>
        <router-link :to="{ name: 'config.patios' }"><span>Pátios</span></router-link>
      </li>
      <li>
        <router-link :to="{ name: 'config.orgao.apreensor' }"><span>Órgão Apreensor</span></router-link>
      </li>
      <li>
        <router-link :to="{ name: 'config.empresa-reboque' }" v-if="ACL.check('gerenciar_configuracoes_reboque', currentUser.id)"><span>Empresa de Reboque</span></router-link>
      </li>
      <li>
        <router-link :to="{ name: 'config.reboque' }" v-if="ACL.check('gerenciar_configuracoes_reboque', currentUser.id)"><span>Reboque</span></router-link>
      </li>
	    <li>
        <router-link :to="{ name: 'config.reboquista' }" v-if="ACL.check('gerenciar_configuracoes_reboquista', currentUser.id)"><span>Reboquista</span></router-link>
      </li>
  	  <li>
        <router-link :to="{ name: 'config.conta.bancaria' }"><span>Conta Bancária</span></router-link>
      </li>
      <li>
        <router-link :to="{ name: 'config.feriado' }"><span>Feriados</span></router-link>
      </li>
      <li>
        <router-link :to="{ name: 'config.tipo-restricao' }"><span>Tipos de Restrições</span></router-link>
      </li>
      <li>
        <router-link :to="{ name: 'config.banco-notificacao' }"><span>Bancos para notificação</span></router-link>
      </li>
      <li>
        <router-link :to="{ name: 'config.grupos' }"><span>Grupos</span></router-link>
      </li>
      <li>
        <router-link :to="{ name: 'config.bem-equipamento' }"><span>Equipamento</span></router-link>
      </li>
    </ul>
  </li>
</template>



// WEBPACK FOOTER //
// Configuracoes.vue?0579c979